import { HotkeyOption } from './hotkey-option';
import { isFloorball, Sport } from './sport';

// Where the attack that led to a shot started. Collectors pick one per shot in
// LITE and LITE_PLUS games. Ice hockey keeps its blue-line scenarios.
export type IceHockeyAttackScenario = 'OZFO' | 'OZ' | 'FC' | 'Rush';

// Floorball follows the swiss unihockey game phase model. The first scenario
// that fits wins, and sustained possession takes every other shot, so every
// shot gets exactly one:
// - set_play: within 5 s after the team's own free hit, hit-in, won face-off
//   or penalty shot
// - forecheck: ball won in the opponent half, shot before the opponent is
//   organised
// - turnover: ball won in the own half (a goalkeeper save included), shot
//   before the opponent is organised
// - sustained_possession: against an organised defence
export type FloorballAttackScenario =
  | 'set_play'
  | 'forecheck'
  | 'turnover'
  | 'sustained_possession';

export type AttackScenario = IceHockeyAttackScenario | FloorballAttackScenario;

// The hotkey is the letter the collector presses once the shot outcome is chosen.
export type AttackScenarioOption = HotkeyOption<AttackScenario>;

const ICE_HOCKEY_ATTACK_SCENARIOS: AttackScenarioOption[] = [
  { value: 'OZFO', label: 'OZFO', hotkey: 'o' },
  { value: 'OZ', label: 'OZ', hotkey: 'z' },
  { value: 'FC', label: 'FC', hotkey: 'f' },
  { value: 'Rush', label: 'Rush', hotkey: 'r' }
];

const FLOORBALL_ATTACK_SCENARIOS: AttackScenarioOption[] = [
  { value: 'set_play', label: 'Set play', hotkey: 's' },
  { value: 'forecheck', label: 'Forecheck', hotkey: 'f' },
  { value: 'turnover', label: 'Turnover', hotkey: 't' },
  {
    value: 'sustained_possession',
    label: 'Sustained possession',
    hotkey: 'p'
  }
];

export function attackScenariosFor(sport: Sport): AttackScenarioOption[] {
  return isFloorball(sport)
    ? FLOORBALL_ATTACK_SCENARIOS
    : ICE_HOCKEY_ATTACK_SCENARIOS;
}
